import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import UiImageCard from "../../components/cards/UiImageCard"
import Gym from "../../../../styles/img/memberships/gym.jpg"
import Odeon from "../../../../styles/img/memberships/odeon.jpg"
import Pelaton from "../../../../styles/img/memberships/pelatonimg.png"
// import Sky from "../../../../styles/img/memberships/sky.jfif"
// import Spa from "../../../../styles/img/memberships/spa.jfif"

export default function Memberships(props) {


    return (
        <>
            <UiCol className="sb-col-medimum" >
                <UiImageCard image={Gym} heading="Gym" ratings="4.8" reviews="122"/>
            </UiCol>
            <UiCol className="sb-col-medimum">
                <UiImageCard image={Odeon} heading="Odeon" ratings="4.8" reviews="122"/>
            </UiCol>
            <UiCol className="sb-col-medimum">
                <UiImageCard image={Pelaton} heading="Pelaton" ratings="4.8" reviews="122"/>
            </UiCol>
            <UiCol className="sb-col-medimum">
                <UiImageCard image={Odeon} heading="Sky" ratings="4.8" reviews="122"/>
            </UiCol>
            <UiCol className="sb-col-medimum">
                <UiImageCard image={Gym} heading="Spa" ratings="4.8" reviews="122"/>
            </UiCol>
        </>
    )
}
